import { SET_USER, SET_USER_SUCCESS } from "core-web/state/models/User/constants";

import Events from "core-web/libs/Events";
import { UserEvents } from "core-web/libs/Events/constants";
import store from "core-web/state/store";

export const setUser = (user) => (dispatch) => {
    if (!user) {
        return;
    }

    dispatch({ type: SET_USER });

    const {
        street,
        city,
        zip_code: zipCode,
        email,
        favorites,
        first_name: firstName,
        interest_animals: interestAnimals,
        last_name: lastName,
        mobile_phone: phoneNumber,
        notification_preferences: notificationPreferences,
        id: userId,
        bonus_card_number: bonuscardNumber,
        bonus_points: bonusPoints,
        member_level: userMemberLevel,
    } = user;

    const memberLevel = userMemberLevel ?? {};

    const transformedMemberLevel = {
        rewardPoints: memberLevel["based_on_reward_points"] ?? 0,
        expires: memberLevel["expires"] ?? null,
        levelId: memberLevel["level_id"] ?? "bronze",
        levelName: memberLevel["level_name"] ?? "Bronze",
        pointsToNextLevel: memberLevel["remaining_to_upgrade"] ?? 0,
    };

    const userData = {
        street,
        city,
        zipCode,
        email,
        favorites,
        firstName,
        interestAnimals,
        lastName,
        phoneNumber,
        notificationPreferences,
        userId,
        bonuscardNumber,
        bonusPoints,
        memberLevel: transformedMemberLevel,
    };

    dispatch({
        type: SET_USER_SUCCESS,
        ...userData,
    });

    Events.trigger(UserEvents.UPDATED, { user: userData });

    return userData;
};

export default (user) => store.dispatch(setUser(user));
